import * as types from '../actions/types';
import initialState from './initialState';
import { default as config } from '../constants';


export default function mandatoriesReducer(state = initialState.mandatories, action) {
	// For these specific actions i want to manipulate state in this
	// way...
	switch (action.type) {
		case types.SAVE_DETAILS_SUCCESS:
			return Object.assign({}, state, action.details);
		case types.SAVE_DETAILS_FAILURE:
			return state
		case types.MOVE_TO_BUDGET_ITEM_SUCCESS:
			return Object.assign({}, state, {currentLine : action.id})
		case types.RESET_CALCULATOR_SUCCESS:
			return Object.assign({}, initialState.estimates);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/mandatoriesReducer.js